import WasmController from 'react-lib/frameworks/WasmController';

import GoogleConnect from 'issara-sdk/apis/GoogleConnect_users';
import GoogleLogin from "issara-sdk/apis/GoogleLogin_users";

import MixInService from "react-lib/apis/services/MixInService";
import { to } from "react-lib/utils";

export type Props = {

}

export type State =
  {
  }

export const StateInitial: State =
  {
  }

export type Event =
  { message: "getPrintAPI", params: any }
  |  { message: "getRegisterByTokenFacebook", params: any }
  |  { message: "postRegisterByTokenFacebook", params: any }
  |  { message: "postRegisterByTokenFacebookConnect", params: any }
  |  { message: "postRegisterByTokenGoogle", params: any }
  |  { message: "postRegisterByTokenGoogleConnect", params: any }

export type Data =
  {
    division?: number,
  }

export const DataInitial =
  {
  }

type Handler = (
  controller: WasmController<State, Event, Data, Props>, params?: any) => any

export const getPrintAPI: Handler = async (controller,
  { printAPI, patientId, encounterId, jasperModule, jasperPath, pdf, orderId, confirm, reason}
) => {
  let params: any = {};
  if (patientId) {
    params.patient_id = patientId;
  }
  if (encounterId) {
    params.encounter_id = encounterId;
  }
  if (jasperModule) {
    params.jasper_module = jasperModule;
  }
  if (jasperPath) {
    params.jasper_path = jasperPath;
  }
  if (pdf) {
    params.pdf = pdf;
  }
  if (orderId) {
    params.order_id = orderId;
  }
  if (confirm) {
    params.confirm = confirm;
  }
  if (reason) {
    params.reason = reason;
  }
  const mixInService = new MixInService(controller.apiToken);
  const [error, response, network] = await to(
    mixInService.getPrintAPI({ printAPI, params, divisionId: controller.data.division })
  );
  return [response, error, network];
}

export const getRegisterByTokenFacebook: Handler = async (
  controller,
  { accessToken, subscription, device_id, app, email }
) => {
  let params: any = {};
  console.log("getRegisterByTokenFacebook... subscription: ", subscription);
  console.log("getRegisterByTokenFacebook... device_id: ", device_id);
  console.log("getRegisterByTokenFacebook... app: ", app);
  console.log("getRegisterByTokenFacebook... email: ", email);
  if (accessToken) {
    params.access_token = accessToken;
  }
  if (subscription) {
    params.device_token = JSON.stringify(subscription);
  }
  if (device_id) {
    params.unique_id = device_id;
    params.device_id = device_id;
    params.device_type = "webpush";
  }
  if (app) {
    params.app = app;
  }
  if (email) {
    params.email = email;
  }
  const mixInService = new MixInService();
  const [error, response, network] = await to(mixInService.getRegisterByTokenFacebook({ params }));
  return [response, error, network];
};


export const postRegisterByTokenFacebook: Handler = async (
  controller,
  { accessToken, subscription, device_id, app, email }
) => {
  let data: any = {};
  console.log("postRegisterByTokenFacebook... subscription: ", subscription);
  console.log("postRegisterByTokenFacebook... device_id: ", device_id);
  console.log("postRegisterByTokenFacebook... app: ", app);
  console.log("postRegisterByTokenFacebook... email: ", email);
  if (accessToken) {
    data.access_token = accessToken;
  }
  if (subscription) {
    data.device_token = JSON.stringify(subscription);
  }
  if (device_id) {
    data.unique_id = device_id;
    data.device_id = device_id;
    data.device_type = "webpush";
  }
  if (app) {
    data.app = app;
  }
  if (email) {
    data.email = email;
  }
  const mixInService = new MixInService();
  const [error, response, network] = await to(mixInService.postRegisterByTokenFacebookV2({ data }));
  return [response, error, network];
};

export const postRegisterByTokenFacebookConnect: Handler = async (
  controller,
  { accessToken, subscription, device_id, app, email }
) => {
  let data: any = {};
  console.log("postRegisterByTokenFacebook... subscription: ", subscription);
  console.log("postRegisterByTokenFacebook... device_id: ", device_id);
  console.log("postRegisterByTokenFacebook... app: ", app);
  console.log("postRegisterByTokenFacebook... email: ", email);
  if (accessToken) {
    data.access_token = accessToken;
  }
  if (subscription) {
    data.device_token = JSON.stringify(subscription);
  }
  if (device_id) {
    data.unique_id = device_id;
    data.device_id = device_id;
    data.device_type = "webpush";
  }
  if (app) {
    data.app = app;
  }
  if (email) {
    data.email = email;
  }
  const mixInService = new MixInService();
  const [error, response, network] = await to(
    mixInService.postRegisterByTokenFacebookConnectV2({ data })
  );
  return [response, error, network];
};

export const postRegisterByTokenGoogle: Handler = async (
  controller,
  { idToken, subscription, device_id, app, email }
) => {
  let data: any = {};

  if (idToken) {
    data.id_token = idToken;
  }
  if (subscription) {
    data.device_token = JSON.stringify(subscription);
  }
  if (device_id) {
    data.unique_id = device_id;
    data.device_id = device_id;
    data.device_type = "webpush";
  }
  if (app) {
    data.app = app;
  }

  return GoogleLogin.post({ data });
};

export const postRegisterByTokenGoogleConnect: Handler = async (
  controller,
  { idToken, subscription, device_id, app, email }
) => {
  let data: any = {};

  if (idToken) {
    data.id_token = idToken;
  }
  if (subscription) {
    data.device_token = JSON.stringify(subscription);
  }
  if (device_id) {
    data.unique_id = device_id;
    data.device_id = device_id;
    data.device_type = "webpush";
  }
  if (app) {
    data.app = app;
  }
  return GoogleConnect.post({ data });
};